import React from "react";

/**
 * AspectToggle — selettore formato (1:1 · 4:5 · 9:16 · 16:9) usato da
 * Post, Reel e Before/After nel Social Studio. Estratto per evitare la
 * triplice ripetizione dello stesso markup.
 */
export default function AspectToggle({ value, onChange, options, testIdPrefix }) {
  return (
    <div className="mb-3" data-testid={`${testIdPrefix}-aspect-toggle`}>
      <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#9A968B] mb-1.5 text-center">
        Formato
      </div>
      <div className="flex items-stretch justify-center gap-1.5 bg-[#F1F4ED] rounded-md p-1">
        {options.map((opt) => (
          <button
            key={opt.v}
            onClick={() => onChange(opt.v)}
            className={`flex-1 px-2 py-2 rounded text-center transition-colors ${
              value === opt.v
                ? "bg-white text-[#1C1C1A] shadow-sm"
                : "text-[#6B6A65] hover:text-[#1C1C1A]"
            }`}
            data-testid={`${testIdPrefix}-aspect-${opt.v}`}
          >
            <div className="text-[10.5px] uppercase tracking-[0.14em] font-bold leading-tight">
              {opt.lbl}
            </div>
            <div className={`text-[9.5px] mt-0.5 ${value === opt.v ? "text-[#7C8B6E]" : "text-[#9A968B]"}`}>
              {opt.hint}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
